<template>
    <div v-if="isCustomerLoaded()">
        <b-modal
            v-model="showModalLocal"
            :title="'Редактирование заказчика'"
            class="modal-primary"
            size="xl"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <b-card>
                <div class="row">
                    <div class="col col-lg-4">
                        <b-form-group
                            label="* Фамилия"
                            :state="validateState('customer_surname')"
                            :invalid-feedback="veeErrors.first('customer_surname')">
                            <b-form-input
                                type="text"
                                v-model="customer.surname"
                                v-validate="{max:30,}"
                                id="customer_surname"
                                name="customer_surname"
                                data-vv-as="'Фамилия'"
                                :state="validateState('customer_surname')"
                                aria-describedby="customer_surname_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col col-lg-4">
                        <b-form-group
                            label="* Имя"
                            :state="validateState('customer_name')"
                            :invalid-feedback="veeErrors.first('customer_name')"
                            required
                        >
                            <b-form-input
                                type="text"
                                v-model="customer.name"
                                v-validate="{max:30,required:true}"
                                id="customer_name"
                                name="customer_name"
                                data-vv-as="'Имя'"
                                :state="validateState('customer_name')"
                                aria-describedby="customer_name_feedback"
                                required
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col col-lg-4">
                        <b-form-group
                            label="Отчество"
                            :state="validateState('customer_patro')"
                            :invalid-feedback="veeErrors.first('customer_patro')">
                            <b-form-input
                                type="text"
                                v-model="customer.patro"
                                v-validate="{max:30, }"
                                id="customer_patro"
                                name="customer_patro"
                                data-vv-as="'Отчество'"
                                :state="validateState('customer_patro')"
                                aria-describedby="customer_patro_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-lg-4">
                        <b-form-group
                            label="E-mail"
                            :state="validateState('customer_email')"
                            :invalid-feedback="veeErrors.first('customer_email')"
                            description="E-mail используется для входа на сайте агентства в качестве логина и для отправки служебных писем"
                        >
                            <b-form-input
                                type="text" id="customer_email"
                                v-model="customer.email"
                                v-validate="{max:60,email:true}"
                                name="customer_email"
                                data-vv-as="'E-mail'"
                                :state="validateState('customer_email')"
                                aria-describedby="customer_email_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col col-lg-4">
                        <b-form-group
                            label="Телефон"
                            :state="validateState('customer_tel')"
                            :invalid-feedback="veeErrors.first('customer_tel')"
                            description="Телефон используется для входа на сайте агентства в качестве логина и для отправки СМС"
                        >
                            <b-form-input
                                type="text" id="customer_tel"
                                v-model="customer.tel"
                                v-validate="{max:20,}"
                                name="customer_tel"
                                data-vv-as="'Телефон'"
                                :state="validateState('customer_tel')"
                                aria-describedby="customer_tel_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col col-lg-4">
                        <b-form-group
                            label="Пароль"
                            :state="validateState('customer_password')"
                            :invalid-feedback="veeErrors.first('customer_password')"
                            description="Пароль для входа пользователя на сайте агентства. Не трогайте, если не планируете менять "
                        >
                            <b-form-input
                                type="text" id="customer_password"
                                v-model="extra.password"
                                v-validate="{max:20,}"
                                name="customer_password"
                                data-vv-as="'Пароль'"
                                :state="validateState('customer_password')"
                                aria-describedby="customer_password_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-lg-2">
                        <b-form-group label="Страна">
                            <b-select
                                :options="countries"
                                v-model="customer.country_id"
                                value-field="id"
                                text-field="title_ru"
                            ></b-select>
                        </b-form-group>
                    </div>

                    <div class="col-8 col-lg-4">
                        <b-form-group
                            :state="validateScopedState('orderform', 'customer_city')"
                            label="Город проживания"
                            :invalid-feedback="veeErrors.first('orderform.customer_city')"
                        >
                            <city-input
                                v-model="customer.city"
                                id="customer_city"
                                v-validate="{max:100}"
                                data-vv-scope="orderform"
                                name="customer_city"
                                data-vv-as="'Город проживания'"
                                :state="validateScopedState('orderform', 'customer_city')"
                            ></city-input>

                        </b-form-group>
                    </div>

                    <div class="col col-12 col-lg-6">
                        <b-form-group
                            label="Почтовый адрес"
                            :state="validateState('customer_mail_address')"
                            :invalid-feedback="veeErrors.first('customer_mail_address')"
                        >
                            <b-form-input
                                type="text" id="customer_mail_address"
                                v-model="customer.mail_address"
                                v-validate="{max:500}"
                                name="customer_mail_address"
                                data-vv-as="'Почтовый адрес'"
                                :state="validateState('customer_mail_address')"
                                aria-describedby="customer_mail_address_feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>


                <hr>

                <b-form-group >
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="customer_is_org" value="1" v-model="customer.is_org">
                        <label class="custom-control-label" for="customer_is_org">Юридическое лицо</label>
                    </div>
                </b-form-group>

                <template v-if="!customer.is_org">
                    <b-form-group
                        label="Паспортные данные"
                        :state="validateState('customer_passport')"
                        :invalid-feedback="veeErrors.first('customer_passport')"
                    >
                        <b-form-input
                            type="text" id="customer_passport"
                            v-model="customer.passport"
                            v-validate="{max:500}"
                            name="customer_passport"
                            data-vv-as="'Паспортные данные'"
                            :state="validateState('customer_passport')"
                            aria-describedby="customer_passport_feedback"
                        ></b-form-input>
                    </b-form-group>
                </template>
                <template v-if="customer.is_org">

                    <b-form-group
                        label="Наименование"
                        :state="validateState('customer_org_name')"
                        :invalid-feedback="veeErrors.first('customer_org_name')"
                    >
                        <b-form-input
                            type="text" id="customer_org_name"
                            v-model="customer.org_name"
                            v-validate="{max:500}"
                            name="customer_org_name"
                            data-vv-as="'Наименование'"
                            :state="validateState('customer_org_name')"
                            aria-describedby="customer_org_name_feedback"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Адрес юридического лица"
                        :state="validateState('customer_org_addr')"
                        :invalid-feedback="veeErrors.first('customer_org_addr')"
                    >
                        <b-form-input
                            type="text" id="customer_org_addr"
                            v-model="customer.org_addr"
                            v-validate="{max:500}"
                            name="customer_org_addr"
                            data-vv-as="'Адрес юридического лица'"
                            :state="validateState('customer_org_addr')"
                            aria-describedby="customer_org_addr_feedback"
                        ></b-form-input>
                    </b-form-group>

                    <div class="row">
                        <div class="col col-lg-4">
                            <b-form-group
                                label="ИНН"
                                :state="validateState('customer_org_inn')"
                                :invalid-feedback="veeErrors.first('customer_org_inn')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_inn"
                                    v-model="customer.org_inn"
                                    v-validate="{inn:true}"
                                    name="customer_org_inn"
                                    data-vv-as="'ИНН'"
                                    :state="validateState('customer_org_inn')"
                                    aria-describedby="customer_org_inn_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-4">
                            <b-form-group
                                label="КПП"
                                :state="validateState('customer_org_kpp')"
                                :invalid-feedback="veeErrors.first('customer_org_kpp')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_kpp"
                                    v-model="customer.org_kpp"
                                    v-validate="{kpp:true}"
                                    name="customer_org_kpp"
                                    data-vv-as="'КПП'"
                                    :state="validateState('customer_org_kpp')"
                                    aria-describedby="customer_org_kpp_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-4">
                            <b-form-group
                                label="ОГРН"
                                :state="validateState('customer_org_ogrn')"
                                :invalid-feedback="veeErrors.first('customer_org_ogrn')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_ogrn"
                                    v-model="customer.org_ogrn"
                                    v-validate="{min:13,max:15}"
                                    name="customer_org_ogrn"
                                    data-vv-as="'ОГРН'"
                                    :state="validateState('customer_org_ogrn')"
                                    aria-describedby="customer_org_ogrn_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-lg-6">
                            <b-form-group
                                label="Должность подписанта"
                                :state="validateState('org_manager_position')"
                                :invalid-feedback="veeErrors.first('org_manager_position')"
                            >
                                <b-form-input
                                    type="text" id="org_manager_position"
                                    v-model="customer.org_manager_position"
                                    v-validate="{max:100}"
                                    name="org_manager_position"
                                    data-vv-as="'Должность подписанта'"
                                    :state="validateState('org_manager_position')"
                                    aria-describedby="org_manager_position_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-6">
                            <b-form-group
                                label="ФИО Подписанта"
                                :state="validateState('customer_org_manager')"
                                :invalid-feedback="veeErrors.first('customer_org_manager')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_manager"
                                    v-model="customer.org_manager"
                                    v-validate="{max:100}"
                                    name="customer_org_manager"
                                    data-vv-as="'ФИО Подписанта'"
                                    :state="validateState('customer_org_manager')"
                                    aria-describedby="customer_org_manager_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-6">
                            <b-form-group
                                label="ФИО Подписанта в родительном падеже"
                                :state="validateState('customer_org_manager_genetive')"
                                :invalid-feedback="veeErrors.first('customer_org_manager_genetive')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_manager_genetive"
                                    v-model="customer.org_manager_genetive"
                                    v-validate="{max:100}"
                                    name="customer_org_manager_genetive"
                                    data-vv-as="'ФИО Подписанта в родительном падеже'"
                                    :state="validateState('customer_org_manager_genetive')"
                                    aria-describedby="customer_org_manager_genetive_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-6">
                            <b-form-group
                                label="На основании чего действует подписант"
                                :state="validateState('customer_org_manager_document')"
                                :invalid-feedback="veeErrors.first('customer_org_manager_document')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_manager_document"
                                    v-model="customer.org_manager_document"
                                    v-validate="{max:100}"
                                    name="customer_org_manager_document"
                                    data-vv-as="'На основании чего действует подписант'"
                                    :state="validateState('customer_org_manager_document')"
                                    aria-describedby="customer_org_manager_document_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-lg-4">
                            <b-form-group
                                label="Расчетный счет"
                                :state="validateState('customer_org_rs')"
                                :invalid-feedback="veeErrors.first('customer_org_rs')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_rs"
                                    v-model="customer.org_rs"
                                    v-validate="{schet:true}"
                                    name="customer_org_rs"
                                    data-vv-as="'Расчетный счет'"
                                    :state="validateState('customer_org_rs')"
                                    aria-describedby="customer_org_rs_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-4">
                            <b-form-group
                                label="Корреспондентский счет"
                                :state="validateState('customer_org_ks')"
                                :invalid-feedback="veeErrors.first('customer_org_ks')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_ks"
                                    v-model="customer.org_ks"
                                    v-validate="{schet:true}"
                                    name="customer_org_ks"
                                    data-vv-as="'Корреспондентский счет'"
                                    :state="validateState('customer_org_ks')"
                                    aria-describedby="customer_org_ks_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col col-lg-4">
                            <b-form-group
                                label="БИК"
                                :state="validateState('customer_org_bik')"
                                :invalid-feedback="veeErrors.first('customer_org_bik')"
                            >
                                <b-form-input
                                    type="text" id="customer_org_bik"
                                    v-model="customer.org_bik"
                                    v-validate="{bik:true}"
                                    name="customer_org_bik"
                                    data-vv-as="'БИК'"
                                    :state="validateState('customer_org_bik')"
                                    aria-describedby="customer_org_ogrn_feedback"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>

                    <b-form-group
                        label="Банк"
                        :state="validateState('customer_org_bank')"
                        :invalid-feedback="veeErrors.first('customer_org_bank')"
                    >
                        <b-form-input
                            type="text" id="customer_org_bank"
                            v-model="customer.org_bank"
                            v-validate="{max:500}"
                            name="customer_org_bank"
                            data-vv-as="'Банк'"
                            :state="validateState('customer_org_bank')"
                            aria-describedby="customer_org_bank_feedback"
                        ></b-form-input>
                    </b-form-group>

                </template>

            </b-card>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_customers } from '@/functions_customers.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import CityInput from '@/components/CityInput'

    export default {
        name: 'EditCustomerDialog',
        mixins: [functions, functions_customers, functions_loaders],
        data: function () {
            return {
                extra: {
                    password: '******'
                }
            };
        },
        components: {
            CityInput
        },
        model: {
            prop: "customer_id",
            event: "hide"
        },
        props: {
            customer_id: [Number],
        },
        methods: {
            reloadCustomer: function() {
                this.resetCustomer().loadCustomer(this.customer_id, this.customerAfterLoad);
            },
            customerAfterLoad: function() {

            },
            onCancel: function() {

            },
            onApply: function () {
                this.saveCustomer(this.extra, function(self){
                    self.reloadView();
                }, this);
            },
            onSave: function () {
                let self = this;
                this.saveCustomer(this.extra, function() {
                    self.backOrRouteTo('/agent/customers');
                });
            },

            handleCancel: function () {
                //console.log('SimpleDialog: handleCancel');
                this.$emit("hide", 0);
            },
            handleOk: function () {
                //console.log('SimpleDialog: handleOk');
                this.onApply();
                this.$emit("hide", 0);
            },
            handleSubmit: function () {
                //console.log('SimpleDialog: handleSubmit');
                this.$emit("hide", 0);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return !!this.customer_id
                },
                set: function (newValue) {}
            }
        },
        created: function() {
            this.loadCountries();
            if (this.customer_id) {
                this.resetCustomer().loadCustomer(this.customer_id, this.customerAfterLoad);
            }
        },
        // mounted: function() {
        //     if (this.customer_id) {
        //     }
        // },
        // updated: function() {
        //     if (this.customer_id) {
        //     }
        // },
        watch: {
            // customer_id: {
            //     handler(newValue) {
            //     },
            //     immediate: true,
            // },
        }
    }
</script>
